import { render, staticRenderFns } from "./property-ad-empty-search.vue?vue&type=template&id=ef3a1084"
import script from "./property-ad-empty-search.vue?vue&type=script&lang=js"
export * from "./property-ad-empty-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports